export enum LocalStorageKeys {
    IS_AUTHENTICATED = 'isAuthenticated',
    PROFILE = 'profile',
    TOKEN = 'token',
    RECENT_SEARCHES = 'recentSearches',
    POST_LOGIN_REDIRECT = 'postLoginRedirect',
    SHARE_PROFILE_MILESTONE_SENT = 'shareProfileMilestoneSent'
}